import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { useListUsersQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'user',
  props: {
    accountId: null,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],
  setup: function setup(__props) {
    var props = __props;
    var attrs = useAttrs();
    var internalQuery = ref(attrs.query);
    watch(function () {
      return attrs.query;
    }, function () {
      internalQuery.value = attrs.query;
    });
    var accountId = computed(function () {
      var _props$accountId, _internalQuery$value;
      return (_props$accountId = props.accountId) !== null && _props$accountId !== void 0 ? _props$accountId : (_internalQuery$value = internalQuery.value) === null || _internalQuery$value === void 0 ? void 0 : _internalQuery$value.accountId;
    });
    var listVariables = computed(function () {
      return _objectSpread(_objectSpread({}, _typeof(internalQuery.value) === 'object' && internalQuery.value !== null ? internalQuery.value : {}), {}, {
        accountId: accountId.value,
        limit: 15
      });
    });
    var _useListUsersQuery = useListUsersQuery(listVariables, computed(function () {
        return {
          enabled: Boolean(accountId.value)
        };
      })),
      usersResult = _useListUsersQuery.result,
      loading = _useListUsersQuery.loading;
    var users = computed(function () {
      var _usersResult$value;
      return ((_usersResult$value = usersResult.value) === null || _usersResult$value === void 0 ? void 0 : _usersResult$value.listUsers) || [];
    });
    return {
      __sfc: true,
      props: props,
      attrs: attrs,
      internalQuery: internalQuery,
      accountId: accountId,
      listVariables: listVariables,
      usersResult: usersResult,
      loading: loading,
      users: users
    };
  }
});